import { ChangeDetectionStrategy, Component, Inject } from "@angular/core";
import { firstValueFrom } from "rxjs";

import { I18nService } from "@bitwarden/common/platform/abstractions/i18n.service";
import {
  ButtonModule,
  DIALOG_DATA,
  DialogModule,
  DialogRef,
  DialogService,
} from "@bitwarden/components";
import { I18nPipe } from "@bitwarden/ui-common";

@Component({
  templateUrl: "./bv-rotate-encryption-key-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DialogModule, ButtonModule, I18nPipe],
})
export class BvRotateEncryptionKeyDialogComponent {
  readonly message: string;

  constructor(
    private readonly dialogRef: DialogRef<boolean>,
    @Inject(DIALOG_DATA) data: { message: string },
  ) {
    this.message = data.message;
  }

  protected close(result: boolean): void {
    void this.dialogRef.close(result);
  }

  static open(dialogService: DialogService, i18nService: I18nService): Promise<boolean> {
    const message = [
      i18nService.t("updateEncryptionKeyWarning"),
      i18nService.t("updateEncryptionKeyAccountExportWarning"),
      i18nService.t("rotateEncKeyConfirmation"),
    ].join(" ");

    const dialogRef = dialogService.open<boolean>(BvRotateEncryptionKeyDialogComponent, {
      data: { message },
    });

    return firstValueFrom(dialogRef.closed).then((result) => result ?? false);
  }
}
